<template>
  <div v-if="error">Invalid request</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AppsShopifyConnect',
  data() {
    return {
      error: false
    }
  },
  async mounted() {
    localStorage.setItem('oauthState', Date.now());
    try {
      const response =  await axios.get(`${process.env.VUE_APP_SHOPIFY_CONNECT}${window.location.search}&state=${localStorage.getItem('oauthState')}`);
      location.href = response.data;
    } catch (error) {
      this.error = true;
    }
  }
}
</script>
